/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 11/18/14
 * Time: 5:35 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var Marionette = require('marionette');
    var Template = require("templates/userBarWidgetsLayout.tmpl");

    var UserBarWidgetsLayout = Marionette.Layout.extend({
        className : "widgets",
        template: Template,
        regions: {
            "personalization": ".personalization-widget",
            "topBarNotification": ".topBarNotification-widget",
            "trail": ".trail-widget"
        }

    });
    return UserBarWidgetsLayout;
});
